import { DriveFileRenameOutline, Folder } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ContentFolderView__ContentFolder } from '../ContentFolderView.generated';

export interface ContentMenuContentFolderProps {
  /** Set by the menu when this is its first child; this component has no element to take it. */
  autoFocus?: boolean;
  canUpdate: boolean;
  item: ContentFolderView__ContentFolder;
  onMove: () => void;
  onRename: () => void;
}

export const ContentMenuContentFolder = ({
  autoFocus,
  canUpdate,
  onMove,
  onRename,
}: ContentMenuContentFolderProps) => {
  const { t } = useTranslation();
  return (
    <>
      <MenuItem autoFocus={autoFocus} disabled={!canUpdate} onClick={onMove}>
        <ListItemIcon>
          <Folder />
        </ListItemIcon>
        <ListItemText>{t('pages.content.menu.move_folder')}</ListItemText>
      </MenuItem>
      <MenuItem disabled={!canUpdate} onClick={onRename}>
        <ListItemIcon>
          <DriveFileRenameOutline />
        </ListItemIcon>
        <ListItemText>{t('pages.content.menu.rename')}</ListItemText>
      </MenuItem>
    </>
  );
};
